module.exports = __webpack_public_path__ + "img/560-42dfb3.png";